'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * DocumentList — the thin standalone screen (#/Documents, also #/PSRS/Document/List) that hosts the Meadow-backed,
 * filterable Documents browse (List + Charts). The DocumentList provider paints the whole screen into
 * #DocumentList-Host. Full browser width via Dashboard Mode. Document cognate of the Observation list.
 */
class DocumentListView extends libPictView
{
	get provider() { return this.pict.providers['DocumentList']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			// Standalone screen is never project-locked — exit any embed carried over from a Project workspace tab.
			if (typeof tmpProvider.exitEmbed === 'function') { tmpProvider.exitEmbed(); }
			tmpProvider._mount = '#DocumentList-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DocumentListView;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentList',
	DefaultRenderable: 'DocumentListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.dol-page { padding: 1.25rem 0 2rem; }
	`,

	Templates:
	[
		{
			Hash: 'DocumentList-Template',
			Template: html`
				<section class="section dol-page">
					<div id="DocumentList-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DocumentListWrap',
			TemplateHash: 'DocumentList-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
